
// ----------------------------------
// -------- WAV AUDIO ------------------
// ----------------------------------


export function initAudioVisualizer() {


    const wavButton = document.getElementById('wavButton');
    const wavAudio = document.getElementById('wavAudio');
    const wavIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M5 17h-5v-10h5v10zm2-10v10l9 5v-20l-9 5zm11.008 2.093c.742.743 1.2 1.77 1.198 2.903-.002 1.133-.462 2.158-1.205 2.9l1.219 1.223c1.057-1.053 1.712-2.511 1.715-4.121.002-1.611-.648-3.068-1.702-4.125l-1.225 1.22zm2.142-2.135c1.288 1.292 2.082 3.073 2.079 5.041s-.804 3.75-2.096 5.039l1.25 1.254c1.612-1.608 2.613-3.834 2.616-6.291.005-2.457-.986-4.681-2.595-6.293l-1.254 1.25z"/></svg>';

    const bars = document.querySelectorAll('.wave-bars div');

    let audioContext, analyser, source, dataArray;

    function setupAudioVisualizer() {
        audioContext = new (window.AudioContext || window.webkitAudioContext)();
        analyser = audioContext.createAnalyser();
        analyser.fftSize = 256; // Tamaño del FFT
        dataArray = new Uint8Array(analyser.frequencyBinCount);

        source = audioContext.createMediaElementSource(wavAudio);
        source.connect(analyser);
        analyser.connect(audioContext.destination);

        visualize();
    }

    function visualize() {
        analyser.getByteFrequencyData(dataArray);

        const step = Math.floor(dataArray.length / bars.length); // Dividimos las frecuencias entre las 20 barras

        bars.forEach((bar, i) => {
            const value = dataArray[i * step]; // Asignamos una frecuencia promedio a cada barra
            bar.style.height = `${value / 3}px`; // Normalizamos el valor para ajustarlo al tamaño visual
        });

        requestAnimationFrame(visualize);
    }

    if (wavButton) {

        wavButton.addEventListener('click', () => {
            if (!audioContext) setupAudioVisualizer();

            if (wavAudio.paused) {
                wavAudio.play();
                wavButton.innerHTML = wavIcon + ' Pausar';
            } else {
                wavAudio.pause();
                wavButton.innerHTML = wavIcon + ' Escuchar';
            }
        });

        wavAudio.addEventListener('ended', () => {
            wavButton.innerHTML = wavIcon + ' Escuchar';
        });



        // Verificar si existe el parámetro ?start=audio en la URL
        const urlParams = new URLSearchParams(window.location.search);

        if (urlParams.get('start') === 'audio') {

            setTimeout(function(){
                const target = document.querySelector('.section__audio');
                const offset = 50;
            
                if (target) {
                const targetPosition = target.getBoundingClientRect().top + window.scrollY - offset;
            
                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
                }

                //setTimeout(function(){
                //    wavButton.click();
                //},2000);

            },1000);

        }	
        

    }


}


